/* ==========================================================================
   spa-analytics-bridge.js
   Sincronización de analíticas para arquitectura SPA + Meta Pixel E-commerce
   (Versión Definitiva con Soporte para Páginas Personalizadas)
   ========================================================================== */

function triggerVirtualPageView() {
  const currentPath = window.location.pathname;
  const fullPath = window.location.pathname + window.location.search;
  const currentUrl = window.location.href;
  const documentTitle = document.title;

  // 1. Forzar actualización del DOM oculto para Meta
  let canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.href = currentUrl;
  
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) ogUrl.setAttribute('content', currentUrl);

  /* =======================================================
     2. META PIXEL (Facebook) - PageView General
     ======================================================= */
  if (typeof fbq === 'function') {
    fbq('track', 'PageView', {
      page_title: documentTitle,
      page_location: currentUrl,
      page_path: currentPath
    });
    console.log('[SPA Analytics] Meta Pixel PageView disparado (URL Dinámica):', fullPath);
  }

  /* =======================================================
     3. META PIXEL (Facebook) - ViewContent (Solo Productos)
     ======================================================= */
  if (currentPath.includes('/products/')) {
    fetch(currentPath + '.js')
      .then(response => response.json())
      .then(product => {
        if (typeof fbq === 'function') {
          fbq('track', 'ViewContent', {
            content_type: 'product',
            content_ids: [product.id.toString()], 
            content_name: product.title,
            value: (product.price / 100).toFixed(2), 
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'COP',
            page_location: currentUrl // Refuerzo forzado de la URL del producto
          });
          console.log('[SPA Analytics] Meta Pixel ViewContent disparado:', product.title);
        }
      })
      .catch(error => console.warn('[SPA Analytics] Error asíncrono en ViewContent:', error));
  }

  /* =======================================================
     4. META PIXEL (Facebook) - ViewCategory (Colecciones)
     ======================================================= */
  if (currentPath.includes('/collections/') && !currentPath.includes('/products/')) {
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'ViewCategory', {
        content_name: documentTitle,
        content_category: currentPath.split('/').pop(), 
        page_location: currentUrl
      });
      console.log('[SPA Analytics] Meta Pixel ViewCategory disparado:', documentTitle);
    }
  }

  /* =======================================================
     5. META PIXEL (Facebook) - ViewPage (Páginas Personalizadas de Shopify)
     ======================================================= */
  if (currentPath.includes('/pages/')) {
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'ViewPage', {
        page_name: documentTitle,
        page_path: currentPath,
        page_location: currentUrl
      });
      console.log('[SPA Analytics] Meta Pixel ViewPage disparado:', documentTitle);
    }
  }

  /* =======================================================
     6. GOOGLE ANALYTICS 4 (gtag.js)
     ======================================================= */
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', {
      page_title: documentTitle,
      page_location: currentUrl,
      page_path: fullPath
    });
    console.log('[SPA Analytics] GA4 PageView disparado:', fullPath);
  }

  /* =======================================================
     7. GOOGLE TAG MANAGER (Opcional, si usas DataLayer)
     ======================================================= */
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'VirtualPageView',
      pageUrl: currentUrl,
      pageTitle: documentTitle
    });
  }

  /* =======================================================
     8. SHOPIFY ANALYTICS NATIVO (Trekkie)
     ======================================================= */
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && typeof window.ShopifyAnalytics.lib.page === 'function') {
    window.ShopifyAnalytics.lib.page(null, { path: fullPath, url: currentUrl });
  }
}

/* =======================================================
   ESCUCHADORES DE EVENTOS DEL MOTOR SPA
   ======================================================= */

document.addEventListener('spa:page-changed', triggerVirtualPageView);

window.addEventListener('popstate', () => {
  setTimeout(triggerVirtualPageView, 50); 
});